var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$res.xsmall())?_c('mobile',_vm._b({},'mobile',_vm.props,false)):_c('desktop',_vm._b({},'desktop',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }